<template>
  <v-form ref="consent" lazy-validation :data-test="testId + '-grid'">
    <v-row>
      <v-col cols="1">
        <v-checkbox
          v-model="consentAck"
          :data-testid="testId + '-checkbox'"
          hide-details
        />
      </v-col>
      <v-col cols="11">
        <template>
          <slot ref="content"></slot>
        </template>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    testId: String,
    isChecked: Boolean,
  },

  data: function() {
    return {
      consentAck: this.isChecked || false,
    };
  },
  watch: {
    consentAck: function() {
      this.$emit("updateAck", this.consentAck);
    },
    isChecked: function() {
      this.consentAck = this.isChecked;
    },
  },
};
</script>
